import { merge } from 'lodash';
import { useState } from 'react';

/**
 * Merge original roots with their given updates
 * @param {Root[]} roots - original roots array
 * @param {Object} updates - layer id to update map
 * @returns {Root[]}
 */
const mergeRootUpdates = (roots, updates = {}) => roots.map((root) => merge({}, root, updates[root.layerId]));

/**
 * Uses local variation roots, track updates and served merge roots
 * @param {String} id - The variation id
 * @param {Root[]} variationRoots - The initial variation roots
 * @returns {[Root[], Function]}
 */
export const useVariationRoots = (id, variationRoots) => {
    const [rootUpdates, setRootUpdates] = useState({});
    const [, forceUpdate] = useState();

    const handleRootUpdates = (updates) => {
        updates.forEach(({ root: { layerId, ...change } }) => {
            rootUpdates[layerId] = merge({}, rootUpdates[layerId], change);
        });

        setRootUpdates(rootUpdates);

        // This is needed because of following fact: We must sets the rootsUpdate initial state as object in order
        // To prevent multi changes overriding each other.
        forceUpdate({});
    };

    const mergedRoots = mergeRootUpdates(variationRoots, rootUpdates);

    return [mergedRoots, handleRootUpdates];
};
